<template>
  <div
    id="chart-drawer-swipe"
    aria-hidden="true"
    class="absolute z-40 w-full overflow-y-auto border-t rounded-t-lg border-gray-700 bg-gray-800 transition-transform -bottom-[10px] left-0 right-0 translate-y-full"
  >
    <div
      @click="this.drawer.toggle()"
      class="px-4 py-1.5 cursor-pointer relative bg-gray-800 z-20 hover:bg-gray-700"
    >
      <span
        class="absolute w-8 h-1 -translate-x-1/2 rounded-lg top-3 left-1/2 bg-gray-600"
      ></span>
      <h5
        id="chart-drawer-swipe-label"
        class="inline-flex items-center gap-1 text-sm text-gray-400"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-4 h-4"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
          />
        </svg>
        Chart
      </h5>
    </div>
    <div class="-mt-[40px]">
      <iframe
        id="dextools-widget"
        class="w-full h-[350px] 2xl:h-[450px]"
        :src="`https://www.dextools.io/widget-chart/en/${this.chain}/pe-light/${this.address}?theme=dark&chartType=1&chartResolution=1&drawingToolbars=false`"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { Drawer } from "flowbite";

export default {
  name: "ChartDrawerSwipe",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    chain: {
      type: String,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      drawer: null,
    };
  },
  watch: {
    open() {
      if (this.$props.open === true) {
        this.drawer.show();
      }
    },
  },
  methods: {},
  mounted() {
    const drawerEl = document.getElementById("chart-drawer-swipe");
    this.drawer = new Drawer(drawerEl, {
      placement: "bottom",
      backdrop: false,
      bodyScrolling: false,
      edge: true,
      edgeOffset: "-bottom-[10px]",
      onShow: () => {
        drawerEl.classList.remove("bottom-0");
        drawerEl.classList.add("-bottom-[45px]");
        this.$parent.openChartDrawerSwipe = true;
      },
      onHide: () => {
        drawerEl.classList.remove("bottom-0");
        drawerEl.classList.remove("-bottom-[45px]");
        this.$parent.openChartDrawerSwipe = false;
      },
    });
  },
  beforeMount() {},
  beforeUnmount() {
    this.$parent.openChartDrawerSwipe = false;
  },
};
</script>
